var render, staticRenderFns
import script from "./SingleBarChart.vue?vue&type=script&lang=js&"
export * from "./SingleBarChart.vue?vue&type=script&lang=js&"
import style0 from "./SingleBarChart.vue?vue&type=style&index=0&id=01005c08&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01005c08",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/tgs-automation/tgs-automation/mojaweb/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('01005c08')) {
      api.createRecord('01005c08', component.options)
    } else {
      api.reload('01005c08', component.options)
    }
    
  }
}
component.options.__file = "src/views/dashboard/SingleBarChart.vue"
export default component.exports